import React, { useState, useEffect } from 'react'
import { MapContainer, TileLayer, Marker, Popup, LayersControl, LayerGroup } from 'react-leaflet'
import { NavLink } from 'react-router-dom'
import { config } from '../../config'
import iconMap from './iconMap'
import styles from '../../css/devices/LocationHistory.module.css'
import stylesDashDevices from '../../css/Dashboards/DashDevices.module.css'
import PropTypes from 'prop-types'
import { formatDate } from './charts/utils/DatesFormats'
import { useTranslation } from 'react-i18next'

export default function Mapa ({ info, type, funcSokLocation, realTime }) {
  const [data, setData] = useState(null)
  const [findDevice, setFindDevice] = useState(false)
  const { t } = useTranslation('map')

  let date = new Date()
  date = date.toLocaleString()

  useEffect(() => {
    if (realTime) {
      funcSokLocation(setData, setFindDevice)
    } else {
      if (info) {
        if (type === 'last') {
          setData([info])
        } else {
          setData(info)
        }
      }
      setFindDevice(false)
    }
  }, [realTime, info])

  if (data) {
    return (
      <>
      {findDevice && <div className={`${stylesDashDevices.findDevice}`}>
        <i className="pi pi-clock" style={{ marginRight: '0.5rem' }}></i>
        <p>{date}</p>
        <div className={`${stylesDashDevices.now}`}>
          <p>{t('label1')}</p>
        </div>
      </div>}
      <MapContainer
        className="divMaps"
        center={type === 'last' ? data[0]?.lat && data[0]?.lon ? [data[0]?.lat, data[0]?.lon] : config.map.center : config.map.center}
        zoom={config.map.zoom_specific}
        scrollWheelZoom={true}
      >
        {type !== 'last'
          ? (
              data?.map((element) =>
                element?.coordinates[0] && element?.coordinates[1] !== null
                  ? (
                  <Marker
                  key={element?.device.id}
                  position={[element?.coordinates[0], element?.coordinates[1]]}
                  icon={iconMap}
                  >
                <Popup>
                  <NavLink
                    to={`/mdm/device/${element?.device.id}`}
                    onClick={() => {
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      })
                    }}
                  >
                    {' '}
                    {t('label2')}
                  </NavLink>
                </Popup>
              </Marker>
                    )
                  : null
              )
            )
          : data?.place
            ? (
          <Marker key={data[0]?.id} position={[data[0]?.lat, data[0]?.lon]} icon={iconMap}>
            <Popup>
              <div className={styles.popup}>
                <span>
                  {t('label3')}
                  {data[0]?.place}
                </span>
              </div>
            </Popup>
          </Marker>
              )
            : data[0]?.address
              ? (<Marker key={data[0]?.id} position={[data[0]?.lat, data[0]?.lon]} icon={iconMap}>
            <Popup>
              <div className={styles.popup}>
                <span>{t('label7')} {data[0]?.lat}</span>
                <span>{t('label8')} {data[0]?.lon}</span>
              </div>
            </Popup>
          </Marker>)
              : (
          <Marker key={data[0]?.id} position={[data[0]?.lat, data[0]?.lon]} icon={iconMap}>
            <Popup>
              <div className={styles.popup}>
                <span>{t('label3')} {data[0]?.place}</span>
                <span>{t('label4')} {formatDate(data[0]?.date)} </span>
                <span>{t('label5')} {data[0]?.type} </span>
              </div>
            </Popup>
          </Marker>
                )}
        <LayersControl position="topright">
          <LayersControl.BaseLayer checked name={t('baseLayers.base1')}>
            <TileLayer
              attribution='&copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ'
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name={t('baseLayers.base2')}>
            {/* Capa de topografía */}
            <TileLayer
              attribution='Tiles &copy; Esri &mdash; Esri, USGS, NOAA'
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name={t('baseLayers.base3')}>
            <LayerGroup>
              {/* Capa de imágenes satelitales */}
              <TileLayer
                // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                url="https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                attribution='&copy; <a href="https://www.esri.com/">Esri</a> &mdash; Source: Esri, Maxar, Earthstar Geographics'
                />
                {/* Capa de calles */}
                <TileLayer
                  url="https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}"
                  attribution='&copy; <a href="https://www.esri.com/">Esri</a> — Roads & Transportation'
                />
            </LayerGroup>
          </LayersControl.BaseLayer>
        </LayersControl>
      </MapContainer>
      </>)
  } else {
    return (
      <MapContainer
        className="divMaps"
        center={config.map.center}
        zoom={config.map.zoom_general}
        scrollWheelZoom={false}
      >
        <LayersControl position="topright">
          <LayersControl.BaseLayer checked name={t('baseLayers.base1')}>
            <TileLayer
              attribution='&copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ'
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name={t('baseLayers.base2')}>
            {/* Capa de topografía */}
            <TileLayer
              attribution='Tiles &copy; Esri &mdash; Esri, USGS, NOAA'
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name={t('baseLayers.base3')}>
            <LayerGroup>
              {/* Capa de imágenes satelitales */}
              <TileLayer
                // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                url="https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                attribution='&copy; <a href="https://www.esri.com/">Esri</a> &mdash; Source: Esri, Maxar, Earthstar Geographics'
                />
                {/* Capa de calles */}
                <TileLayer
                  url="https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}"
                  attribution='&copy; <a href="https://www.esri.com/">Esri</a> — Roads & Transportation'
                />
            </LayerGroup>
          </LayersControl.BaseLayer>
        </LayersControl>
      </MapContainer>
    )
  }
}

Mapa.propTypes = {
  funcSokLocation: PropTypes.func,
  type: PropTypes.string,
  info: PropTypes.object,
  realTime: PropTypes.bool/* ,
  setFindDevice: PropTypes.func */
}
